import type { PropType } from 'vue';
import type { TDropdownItemprops } from './TDropdown.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useStyles } from './TDropdownItem.styles';

export const TDropdownItem = defineComponent({
  name: 'TDropdownItem',
  emits: ['click'],
  props: {
    disabled: Boolean as PropType<TDropdownItemprops['disabled']>,
  },
  setup(_props, { slots, emit, attrs }) {
    const props = computed(() => merge({}, _props, attrs));

    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      {
        [`${baseClass.value}--disabled`]: props.value.disabled,
      },
    ]);

    const handleClick = () => {
      if (!props.value.disabled) {
        emit('click');
      }
    };

    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && !props.value.disabled) {
        emit('click');
        event.preventDefault();
      }
    };

    return () => (
      <div
        class={classes.value}
        onClick={handleClick}
        role="menuitem"
        tabindex={0}
        onKeydown={handleKeydown}
        aria-disabled={props.value.disabled}
      >
        {slots.default?.()}
      </div>
    );
  },
});
